module.exports = __webpack_public_path__ + "static/media/menuLogo.f0707a78.svg";